export default __webpack_public_path__ + "static/media/01AW3AUG66.7c6a47e7.jpg";